const initialstate = {
  fetching: null,
  fetchingPagination: null,
  fetchingSuccessful: null,
  fetchingFailed: null,
  error: null,
  errorText: null,
  playbooks: [],
  emptyList: null,
  lastTime: null,
};

const getAllGeneratedPlaybooksReducer = (state = initialstate, action) => {
  switch (action.type) {
    case 'GETTING_ALL_GENERATED_PLAYBOOK':
      return Object.assign({}, state, {
        fetching: true,
        fetchingPagination: false,
      });
    case 'GETTING_ALL_GENERATED_PLAYBOOK_WITH_PAGINATION':
      return Object.assign({}, state, {
        fetching: false,
        fetchingPagination: true,
      });
    case 'GETTING_ALL_GENERATED_PLAYBOOK_DONE':
      return Object.assign({}, state, {
        fetching: false,
        fetchingPagination: false,
        fetchingSuccessful: true,
        fetchingFailed: false,
        error: false,
        errorText: '',
        playbooks: action.payload.playbooks,
        lastTime: action.payload.lastTime
          ? action.payload.lastTime
          : state.lastTime,
        emptyList: false,
      });
    case 'ADD_PLAYBOOKS_TO_ALL_GENERATED_PLAYBOOKS':
      return Object.assign({}, state, {
        fetching: false,
        fetchingSuccessful: true,
        fetchingPagination: false,
        fetchingFailed: false,
        playbooks: Array.isArray(action.payload.playbooks)
          ? state.playbooks
            ? state.playbooks.concat(action.payload.playbooks)
            : action.payload.playbooks
          : state.playbooks,
        emptyList:
          Array.isArray(action.payload.playbooks) &&
          (action.payload.playbooks.length === 0 ||
            action.payload.playbooks.length % 15 > 0)
            ? true
            : false,
        lastTime: action.payload.lastTime
          ? action.payload.lastTime
          : state.lastTime,
        error: false,
        errorText: '',
      });
    case 'GETTING_ALL_GENERATED_PLAYBOOK_FAILED':
      return Object.assign({}, state, {
        fetching: false,
        fetchingFailed: true,
        fetchingPagination: false,
        error: true,
        errorText: action.payload,
        playbooks: [],
        emptyList: false,
        lastTime: '',
      });
    case 'GETTING_ALL_GENERATED_PLAYBOOK_WITH_PAGINATION_FAILED':
      return Object.assign({}, state, {
        fetchingPagination: false,
      });
    default:
      return state;
  }
};

export default getAllGeneratedPlaybooksReducer;
